export const USER_ACTIVITY = 'user';
export const TEAM_ACTIVITY = 'team';
export const COURSES = 'content';
export const ACCOUNT = 'account';
export const skillDiveColumnName = 'Skill Dive';
export const skillSonarColumnName = 'Skill Sonar';
export const usersColumnName = 'Users';
export const coursesColumnName = 'Courses';
export const teamColumnName = 'Team';
export const noUserOption = 'no-user';

export const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export const ENTERPRISE_PLAN_URL = 'https://ine.com/enterprise';
export const CUSTOM_REPORTS_FEATURE_SLUG = 'create_custom_reports';

export const CUSTOM_REPORTS_RESTRICTED_COPY = {
  title: 'Prefer a custom report?',
  description: 'Upgrade to Enterprise to schedule and export custom reports.',
  learnMore: 'Learn more',
  accessibleLabel: 'Custom reports are available with Enterprise',
};

export const RESTRICTED_CUSTOM_REPORTS_BANNER_COLORS = {
  background: '#F9F9FC',
  accent: '#6750A3',
};

export const SCHEDULED_REPORTS_RESTRICTED_COPY = {
  title: 'Scheduled reports are available with Enterprise.',
  description: 'Upgrade to Enterprise to schedule and export custom reports.',
  learnMore: 'Learn more',
};

export const SCHEDULED_REPORT_STATUS_COPY = {
  paused: 'Paused - Not sending',
  active: 'Scheduled and active',
};

export const CUSTOM_REPORT_SCHEDULING_BLOCKED_COPY =
  'Upgrade to Enterprise to resume custom report scheduling';

export const SCHEDULED_REPORT_NA_VALUE = 'NA';

export const REPORTING_TEST_IDS = {
  customReportsRestrictedBanner: 'custom-reports-restricted-banner',
  scheduledReportsRestrictedFallback: 'scheduled-reports-restricted-fallback',
};
